/**
 * @description: 会员积分明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="mr-hjm-report">
        <div class="hjm-list" v-show="!showHjmDet">
            <el-form :inline="true" size="small" :model="hjm_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="hjm_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="hjm_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="hjm_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="hjm_list_form.shop_id" filterable placeholder="请选择门店" @change="getRoom">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="hjm_list_form.room_id" filterable clearable placeholder="请选择包厢号" :disabled="hjm_list_form.room_disabled">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="积分类型">
                    <el-select v-model="hjm_list_form.type" clearable placeholder="请选择积分类型">
                        <el-option label="消费获得积分" value="1"></el-option>
                        <el-option label="消费退款扣减积分" value="2"></el-option>
                        <el-option label="积分兑换" value="3"></el-option>
                        <el-option label="兑换退货返还积分" value="4"></el-option>
                        <el-option label="积分抵扣金额" value="5"></el-option>
                        <el-option label="手动修改积分" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="积分变化">
                    <el-select v-model="hjm_list_form.action" clearable placeholder="请选择积分变化">
                        <el-option label="增加" value="1"></el-option>
                        <el-option label="减少" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="hjm_list_form.content">
                        <el-select class="el-slot-select" v-model="hjm_list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="会员卡号" value="vip_card"></el-option>
                            <el-option label="会员姓名" value="vip_name"></el-option>
                            <el-option label="会员手机号" value="vip_mobile"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="hjmQuery">查询</el-button>
                    <el-button @click="hjmExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="hjm_list">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="create_time" label="时间"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="vip_card" width="110" label="会员卡号"></el-table-column>
                <el-table-column prop="vip_name" label="会员姓名"></el-table-column>
                <el-table-column prop="vip_mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="type_name" label="积分类型"></el-table-column>
                <el-table-column prop="points" label="积分"></el-table-column>
                <el-table-column prop="before_points" label="操作前积分"></el-table-column>
                <el-table-column prop="after_points" label="操作后积分"></el-table-column>
                <el-table-column prop="action_name" label="积分变化"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="hjmDet(scope.row.bill_no)">{{scope.row.bill_no != '' ? '查看账单' : ''}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">积分获得总计:</label>
                    <div class="list-total">{{hjm_total_points}}</div>
                    <label class="list-label-6">积分使用总计:</label>
                    <div class="list-total">{{hjm_total_use_points}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="hjm_list_page"
                    :total="hjm_list_total"
                    @current-change="getHjmList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="hjm_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="hjm_export_sign" v-model="hjm_export_all" @change="hjmExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="hjm_export_ids" @change="hjmExportChange">
                    <el-checkbox label="create_time">时间</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="room_name">包厢号</el-checkbox>
                    <el-checkbox label="vip_card">会员卡号</el-checkbox>
                    <el-checkbox label="vip_name">会员姓名</el-checkbox>
                    <el-checkbox label="vip_mobile">会员手机号</el-checkbox>
                    <el-checkbox label="type">积分类型</el-checkbox>
                    <el-checkbox label="points">积分</el-checkbox>
                    <el-checkbox label="before_points">操作前积分</el-checkbox>
                    <el-checkbox label="after_points">操作后积分</el-checkbox>
                    <el-checkbox label="action">积分变化</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="hjm_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="hjm_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
        <div class="hjm-det" v-show="showHjmDet">
            <billDetail ref="hjm_bill_det" @backBdwPre="showHjmDet = false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_list: [],
                showHjmDet: false,
                hjm_list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    room_id: '',
                    content: '',
                    select: 'vip_card',
                    type: '',
                    action: ''
                },
                hjm_total_points: '',
                hjm_total_use_points: '',
				hjm_list: [],
				hjm_list_page: 1,
                hjm_list_total: 0,
                hjm_export_sign: false,
				hjm_export_all: false,
                hjm_export_ids: [],
                hjm_export_list: ['create_time', 'shop_name', 'room_name', 'vip_card', 'vip_name', 'vip_mobile', 'type', 'points', 'before_points', 'after_points', 'action'],
                hjm_export_type: '1',
            }
        },
        components: {
            "billDetail": billDetail
        },
        mounted: function() {
            // 日期
            this.hjm_list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.hjm_list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.hjm_list_form.shop_id = this.shop_list[0].id;
                this.getRoom(this.shop_list[0].id);
                this.getHjmList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.hjm_list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hjm_list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.hjm_list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hjm_list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.hjm_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.hjm_list_form.start_time = start.format('YYYY-MM-DD HH:mm');
                    _this.hjm_list_form.end_time = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.hjm_list_form.room_id = '';
                    _this.hjm_list_form.room_disabled = true;
                } else {
                    _this.hjm_list_form.room_id = '';
                    _this.hjm_list_form.room_disabled = false;
                    _this.setShopDefaultTime(shop_id)
                    Vue.axios.post('Shop/getAllRoom', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },



            getHjmList(page) {
				const _this = this;

                _this.loading = true;
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(_this.hjm_list_form.select == 'vip_card') {
                    vip_card = _this.hjm_list_form.content;
                } else if(_this.hjm_list_form.select == 'vip_name') {
                    vip_name = _this.hjm_list_form.content;
                } else if(_this.hjm_list_form.select == 'vip_mobile') {
                    vip_mobile = _this.hjm_list_form.content;
                }
				Vue.axios.post('FinanceReport2/vipPointsLogDetail', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.hjm_list_form.start_time,
                            "end_time": _this.hjm_list_form.end_time,
                            "shop_id": _this.hjm_list_form.shop_id,
                            "room_id": _this.hjm_list_form.room_id,
                            "type": _this.hjm_list_form.type,
                            "action": _this.hjm_list_form.action,
                            "vip_card": vip_card,
                            "vip_name": vip_name,
                            "vip_mobile": vip_mobile
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.hjm_list_total = Number(res.data.response.count);
							_this.hjm_total_points = res.data.response.total_points;
							_this.hjm_total_use_points = res.data.response.total_use_points;
						}
						_this.hjm_list = res.data.response.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 查询
			hjmQuery() {
				this.getHjmList(1);
            },
            // 导出
            hjmExportAll(val) {
				this.hjm_export_ids = val ? this.hjm_export_list : [];
				this.hjm_export_sign = false;
			},
			hjmExportChange(val) {
				const len = val.length;
				this.hjm_export_all = len === this.hjm_export_list.length;
				this.hjm_export_sign = len > 0 && len < this.hjm_export_list.length;
			},
            hjmExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport2/vipPointsLogDetailExport"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.hjm_export_ids = res.data.response.result.export_fields;
                            _this.hjm_export_type = res.data.response.result.export_type;
                        } else {
                            _this.hjm_export_ids = _this.hjm_export_list;
                            _this.hjm_export_type = '1';
                        }
                        _this.hjmExportChange(_this.hjm_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.hjm_list_export)
                }, function() {
                    _this.hjmExport();
                });
            },
            hjmExport: function() {
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(this.hjm_list_form.select == 'vip_card') {
                    vip_card = this.hjm_list_form.content;
                } else if(this.hjm_list_form.select == 'vip_name') {
                    vip_name = this.hjm_list_form.content;
                } else if(this.hjm_list_form.select == 'vip_mobile') {
                    vip_mobile = this.hjm_list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/vipPointsLogDetailExport" +
                    "?start_time=" + this.hjm_list_form.start_time +
                    "&end_time=" + this.hjm_list_form.end_time +
                    "&shop_id=" + this.hjm_list_form.shop_id +
                    "&room_id=" + this.hjm_list_form.room_id +
                    "&type=" + this.hjm_list_form.type +
                    "&action=" + this.hjm_list_form.action +
                    "&vip_card=" + vip_card +
                    "&vip_name=" + vip_name +
                    "&vip_mobile=" + vip_mobile +
                    "&export_fields=" + JSON.stringify(this.hjm_export_ids) +
                    "&export_type=" + this.hjm_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
            // 查看账单
            hjmDet(bill_no) {
                this.$refs.hjm_bill_det.getBdwDetail(bill_no);
                this.showHjmDet = true;
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>